export default __webpack_public_path__ + "locales/hy-AM/Translations.json?hash=454f47baa3b337821c2763d5247f33c8";